/**
 * API de Empleados
 * Llamadas relacionadas con empleados
 */
import apiClient from './axios.config';

const ENDPOINT = 'api/empleados';


/**
 * Obtiene información de un empleado por legajo
 * @param {string|number} legajo 
 * @returns {Promise<{nombre: string}>}
 */
export const getEmpleadoByLegajo = async (legajo) => {
  const { data } = await apiClient.get(`${ENDPOINT}/${legajo}`);
  return data;
};

/**
 * Obtiene todos los empleados
 * @returns {Promise<Array<{Legajo: string, NmEmpleado: string, Turno: string, Funcion: string}>>}
 */
export const getAllEmpleados = async () => {
  const { data } = await apiClient.get(`${ENDPOINT}`);
  return data;
};


const empleadosApi = {
  getEmpleadoByLegajo,
  getAllEmpleados,
};

export default empleadosApi;
